import { BaseCurrencyInput, Label, Radio, Select } from "@components";
import { useEffect, useState } from "react";

export const TimeForm = ({ node, onChange, onSave }) => {
  const [controllerInputsDate, setControllerInputsDate] = useState(
    node.data?.inLast !== undefined ? "in-last" : "all-days"
  );
  const [customPeriod, setCustomPeriod] = useState(null);
  const [inLast, setInLast] = useState(node.data.inLast || null);
  const [inLastPeriod, setInLastPeriod] = useState(
    node.data.inLastPeriod || "DAY"
  );

  const getFreshNode = () => {
    const dataValue = {
      ...(node?.data || {}),
      inLast,
      inLastPeriod,
    };

    if (controllerInputsDate == "all-days") {
      dataValue.inLast = undefined;
      dataValue.inLastPeriod = undefined;
    }

    return {
      ...node,
      data: dataValue,
    };
  };

  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [inLast, inLastPeriod]);

  return (
    <>
      <Label>Determine o tempo</Label>

      <Radio
        text="Todo o período"
        family="time"
        value="all-days"
        checked={controllerInputsDate}
        className="mb-15"
        onChange={() => setControllerInputsDate("all-days")}
      />

      <Radio
        text="Nos últimos"
        family="time"
        value="in-last"
        checked={controllerInputsDate}
        className="mb-15"
        onChange={() => setControllerInputsDate("in-last")}
      />

      {/* <Radio
        text="Período personalizado"
        family="time"
        value="custom-days"
        checked={controllerInputsDate}
        className="mb-15"
        onChange={() => setControllerInputsDate("custom-days")}
      /> */}

      {controllerInputsDate === "in-last" && (
        <>
          <div className="d-flex">
            <BaseCurrencyInput
              placeholder="Inserir valor"
              className="w-50"
              precision={0}
              prefix=""
              type="tel"
              value={inLast}
              onChange={(v) => setInLast(v)}
            />
            <Select
              title="Selecione o tempo..."
              className="w-50 ml-15"
              value={inLastPeriod}
              options={[
                { label: "Dias", value: "DAY" },
                { label: "Meses", value: "MONTH" },
                { label: "Anos", value: "YEAR" },
              ]}
              onChange={(e) => setInLastPeriod(e.target.value)}
            />
          </div>
        </>
      )}

      {/* {controllerInputsDate === "custom-days" && (
        <>
          <div className="d-flex">
            <div className="d-flex flex-column w-50">
              <span className={styles.miniLabel}>De</span>
              <Input
                placeholder="dd/mm/aaaa"
                mask="99/99/9999"
                type="tel"
                value={customPeriod?.from}
                onChange={(v) => setCustomPeriod({ ...customPeriod, from: v })}
                label="De"
              />
            </div>
            <div className="d-flex flex-column w-50 ml-15">
              <span className={styles.miniLabel}>Até</span>
              <Input
                placeholder="dd/mm/aaaa"
                mask="99/99/9999"
                type="tel"
                value={customPeriod?.to}
                onChange={(v) => setCustomPeriod({ ...customPeriod, to: v })}
                label="Até"
              />
            </div>
          </div>
        </>
      )} */}
    </>
  );
};
